import React, {useState} from "react";

import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import {Dialog} from "../../../../designSystem/components/Dialog";

import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {MeasureNavbar} from "../MeasureNavbar";

import {AddMeasureFeature} from "../AddMeasureFeature";
import {ProfileEditFeature} from "../ProfileEditFeature";
import {MeasurementVisualizationFeature} from "../MeasurementVisualizationFeature";

import {getLiffId} from "../../../../utils/liff";
import {useMeasureFlowFeature} from "../../hooks/useMeasureFlowFeature";
import {useLineLogin} from "../../../../hooks/useLineLogin";

enum TAB {
  INPUT = 'input',
  PROFILE = 'profile',
  VISUALIZATION = 'visualization',
}

export const MeasureFlowFeature = () => {
  // states
  const [selectedTab, setSelectedTab] = useState<TAB | ''>(TAB.INPUT);
  const [selectedMetric, setSelectedMetric] = useState<string>('');

  // hook
  const { lineUserId } = useLineLogin({ liffId: getLiffId('MEASURE_PAGE') });
  const {
    fetch,
    dialogContent,
    guest,
    isGuestValid,
    handleShowPersonalInfoForm,
    handleCloseModal
  } = useMeasureFlowFeature({ lineUserId });

  return (
    <React.Fragment>
      <FormPageLayout
        body={
          <React.Fragment>
            { guest === null
              ? <LoadingView />
              : (
                <React.Fragment>
                  <MeasureNavbar
                    onClickLeftButton={() => isGuestValid ? setSelectedTab(TAB.INPUT) : handleShowPersonalInfoForm}
                    onClickMiddleButton={() => isGuestValid ? setSelectedTab(TAB.VISUALIZATION) : handleShowPersonalInfoForm}
                    onClickRightButton={() => setSelectedTab(TAB.PROFILE)}
                    selectedTab={selectedTab}
                  />
                  { selectedTab === TAB.INPUT && (
                    <AddMeasureFeature
                      onChangeSelectedMetric={metricKey => setSelectedMetric(metricKey)}
                      lineUserId={lineUserId}
                      onSwitchToVisualization={() => setSelectedTab(TAB.VISUALIZATION)}
                    />
                  )}
                  { selectedTab === TAB.VISUALIZATION && (
                    <MeasurementVisualizationFeature
                      defaultSelectedMetric={selectedMetric}
                    />
                  )}
                  { selectedTab === TAB.PROFILE && (
                    <ProfileEditFeature
                      guest={guest}
                      lineUserId={lineUserId}
                      onRefreshData={fetch}
                    />
                  )}
                </React.Fragment>
              )}
          </React.Fragment>
        }
      />

      <Dialog isOpen={dialogContent !== ''}>
        {dialogContent === 'fillUpPersonalInfo' ? (
          <TwoButtonDialog
            type="warning"
            title="請先完備個人資料"
            leftLabel="OK"
            leftOnClick={() => {
              setSelectedTab(TAB.PROFILE)
              handleCloseModal();
            }}
            leftIconName="fa-check"
          />
        ) : null}
      </Dialog>
    </React.Fragment>
  );
};
